import styled from 'styled-components';
import { Breakpoints, FontWeight } from '../../../../styled/constants';
import { FlexBetween } from '../../../../styled/common';

const helvetica = `'Helvetica Neue', Helvetica, Arial, sans-serif`;

export const Title = styled.h1`
  font-size: 32px;
  color: ${({ theme }) => theme.colors.text.tertiary};
  font-weight: ${FontWeight.thin};
  padding: 0;
  margin: 0;

  @media (max-width: ${Breakpoints.smallDesktop}px) {
    font-size: 24px;
  }

  @media (max-width: ${Breakpoints.tablet}px) {
    margin-bottom: 20px;
  }
`;

export const FilterContainer = styled(FlexBetween)`
  padding-bottom: 26px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.primaryReverse};
  margin-bottom: 40px;

  @media (max-width: ${Breakpoints.tablet}px) {
    flex-direction: column;
    padding-bottom: 16px;
    align-items: flex-start;
  }
`;

export const FilterButtons = styled.div`
  display: flex;
  gap: 10px;
  padding: 5px;
  border-radius: 50px;
  border: 1px solid rgba(255, 255, 255, 0.15);
`;

export const FilterButton = styled.button<{ active: boolean }>`
  padding: 10px 15px;
  border-radius: 20px;
  background-color: ${({ active }) => (active ? '#2d2e2f' : 'transparent')};
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: pointer;
  font-size: 14px;
  font-family: ${helvetica};
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background-color: #2d2e2f;
  }
`;
